<template>
  <v-container fill-height fluid grid-list-xl>
    <v-flex>
      <material-card title="Shipment" color="primary">
        <template slot='headerActions'>
          <v-btn top color="secondary" @click="$router.push('/shipments')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <div v-on="on" class="d-inline-block">
                  <v-btn top v-if="!isNew && isEMNCarrier && shipment.status != 'Created'" color="secondary" @click="qrCodeLink">
                    <v-icon>mdi-qrcode</v-icon>
                  </v-btn>
                </div>

              </template>
              <span>QR Code link</span>
            </v-tooltip>
        </template>
        <v-row>
          <v-col cols="1" v-if="$route.params.id">
            <v-tooltip top color="white">
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" :disabled="loading || !prevShipmentId" @click="navigateShipment(prevShipmentId)"  color="secondary">
                  <v-icon>mdi-arrow-left</v-icon>
                  Prev
                </v-btn>
              </template>
              <span>Prev</span>
            </v-tooltip>
          </v-col>
          <v-col>
              <v-form class="mt-4" ref="form" _lazy-validation v-model="validForm" autocomplete="off" role="presentation">
                <v-container grid-list-md>
                  <slot name="prebody"></slot>
                  <v-layout wrap>

                    <v-flex xs12 sm12 md12>
                      <app-point-autocomplete :id="'input_pickupPoint'" dataTest="pickupPoint" label="Pickup Point"
                        :rules="validators[config.entityName].pickupPoint" v-model="shipment.pickup_id"
                        :disabled="!(isNew || ((isAdmin || isEMN) && (shipment.status == 'Created' || shipment.status == 'Draft')))"
                        @inputObj="setPickupPoint" :filters="pickupPointFilters()"></app-point-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <app-point-autocomplete :id="'input_deliveryPoint'" dataTest="deliveryPoint" label="Delivery Point"
                        :rules="validators[config.entityName].deliveryPoint" v-model="shipment.delivery_id"
                        :disabled="!(isNew || ((isAdmin || isEMN) && (shipment.status == 'Created' || shipment.status == 'Draft')))"
                        @inputObj="setDeliveryPoint" :filters="deliveryPointFilters()"></app-point-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm3 md3>
                      <app-autocomplete :id="'input_protocol'" data-test="protocol"
                        v-if="(this.pickupPoint && !this.pickupPoint.site_id) || !this.pickupPoint" label="Protocol"
                        entity="protocol" itemText="name" itemValue="id"
                        :filters="(val) => { return { 'name': '%' + val + '%' } }"
                        :rules="validators[config.entityName].protocol" v-model="shipment.protocol_id"
                        :disabled="!isNew && shipment.status != 'Created' && shipment.status != 'Draft'"></app-autocomplete>


                      <app-autocomplete :id="'input_protocol'" data-test="protocol" ref="protocolSiteAutocomplete"
                        v-if="this.pickupPoint && this.pickupPoint.site_id"
                        :label="'Protocols of site [' + this.pickupPoint.site.code + ']'" entity="protocol_has_site"
                        itemText="protocol.name" itemValue="protocol.id"
                        :filters="(val) => { let f = { 'site_id': this.pickupPoint.site_id }; if (val) { f['protocol.name'] = '%' + val + '%' } return f }"
                        :rules="validators[config.entityName].protocol" v-model="shipment.protocol_id"
                        :disabled="!isNew && shipment.status != 'Created' && shipment.status != 'Draft'"></app-autocomplete>

                    </v-flex>

                    <v-flex xs12 sm3 md3>
                      <v-text-field v-if="shipment.heading" label="To attention of" v-model="shipment.heading"
                        :disabled="!isNew && shipment.status != 'Created' && shipment.status != 'Draft'"></v-text-field>

                      <v-select :id="'input_toAttentionOf'" clearable label="To attention of" color="primary" :items="toAttentionOf" item-value="id"
                        :item-text="item => `${item.name} ${item.surname}`" v-model="shipment.to_attention_of"
                        :disabled="(!isNew && shipment.status != 'Created' && shipment.status != 'Draft') || !shipment.delivery_id"
                        v-if="!shipment.heading" :rules="validators[config.entityName].to_attention_of"></v-select>

                    </v-flex>

                    <v-flex xs12 sm3 md3>
                      <v-select :id="'input_carrier'" data-test="carrier" clearable label="Carrier" color="primary"
                        :items="['EMN Logistic', 'DHL', 'FEDEX', 'MARKEN', 'SPECIAL SERVICES', 'TNT', 'UPS','AIT Worldwide']"
                        v-model="shipment.carrier"
                        :disabled="(!isNew && shipment.status != 'Created' && shipment.status != 'Draft') || isSite || isLab"></v-select>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field :id="'input_trackingNumber'" :disabled="isEMNCarrier || shipment.status == 'Canceled'" label="Tracking Number"
                        :rules="validators[config.entityName].tracking_number" v-model="shipment.tracking_number"
                        :readonly="isSite || isLab"></v-text-field>
                    </v-flex>

              <v-flex xs12 sm2 md2>
                <v-menu :disabled="!isNew && (shipment.status != 'Created' && shipment.status != 'Draft') && (!isAdmin && !isEMN)"
                  v-model="menu_datePicker_pickupDate" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :id="'input_pickupDate'" data-test="pickupDate"
                      :disabled="!isNew && (shipment.status != 'Created' && shipment.status != 'Draft') && (!isAdmin && !isEMN)"
                      v-model="shipment.pickup_date" label="Pickup date" prepend-icon="mdi-calendar" readonly clearable
                      :rules="isAdmin || isEMN ? validators[config.entityName].pickup_date : validators[config.entityName].pickup_date_not_admin" v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker :allowed-dates="allowedDates"
                    :disabled="!isNew && (shipment.status != 'Created' && shipment.status != 'Draft') && (!isAdmin && !isEMN)" clearable
                    v-model="shipment.pickup_date" @input="menu_datePicker_pickupDate = false"></v-date-picker>
                </v-menu>
              </v-flex>



                    <v-flex xs12 sm3 md3>

                      <app-time-range-picker :id="'input_pickupTimeInterval'" inputLabel="Pickup Time Interval" v-model="shipment.pickup_hour" full-width
                        :outerIcon="null" step="30" :disabled="pickupTimeIntervalDisabled" />

                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <!-- issue 197 -->
                      <!--
                      <v-text-field :id="'input_deliveryWithin'" label="Delivery Within" v-model="shipment.delivery_within" type="number"
                        rules=""
                        :disabled="(shipment.heading && shipment.heading.length != 0) || shipment.status == 'Canceled'"></v-text-field>
                      -->
                      <v-select :id="'input_deliveryWithin'" data-test="deliveryWithin" clearable label="Delivery Within" color="primary"
                        :items="[
                          { text: 'No value', value: null }, 
                          { text: '24 h', value: 1 },  //From 0 to 24
                          { text: '48 h', value: 2 } , //From 24 to 48  
                          { text: '72 h', value: 3 }   //From 48 
                        ]"
                        v-model="shipment.delivery_within"
                        :disabled="(shipment.heading && shipment.heading.length != 0) || shipment.status == 'Canceled'"></v-select>
                      <!-- issue 197 -->
                    </v-flex>

                    <v-flex xs12 sm3 md3>
                      <v-text-field v-if="isEMNCarrier" label="Pickup Datetime" v-model="shipment.pickup_datetime"
                        disabled></v-text-field>


                      <app-datetime-picker :id="'input_pickupDatetime'" v-if="!isEMNCarrier" label="Pickup Datetime" v-model="shipment.pickup_datetime"
                        :disabled="shipment.status != 'Confirmed'" />


                    </v-flex>

                    <v-flex xs12 sm3 md3>

                      <v-text-field v-if="isEMNCarrier" label="Delivery Datetime" v-model="shipment.delivery_datetime"
                        disabled></v-text-field>

                      <app-datetime-picker :id="'input_deliveryDatetime'" v-if="!isEMNCarrier" label="Delivery Datetime" v-model="shipment.delivery_datetime"
                        :disabled="shipment.status != 'Shipped'" />

                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-tooltip top max-width="500" :disabled="!pickupNoteDisabled || !shipment.pickup_note">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-text-field :id="'input_pickupNote'" label="Pickup note" v-model="shipment.pickup_note"
                              :disabled="pickupNoteDisabled"></v-text-field>
                          </div>
                        </template>
                        <span class="note-tooltip">{{ shipment.pickup_note }}</span>
                      </v-tooltip>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-tooltip top max-width="500" :disabled="!deliveryNoteDisabled || !shipment.delivery_note">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-text-field :id="'input_deliveryNote'" label="Delivered note" v-model="shipment.delivery_note"
                              :disabled="deliveryNoteDisabled"></v-text-field>
                          </div>
                        </template>
                        <span class="note-tooltip">{{ shipment.delivery_note }}</span>
                      </v-tooltip>
                    </v-flex>

                    <!--v-flex xs12 sm1 md1 v-if="(isAdmin || isEMN) && isEMNCarrier">
                          <v-text-field
                            label="Discount %"
                            v-model="shipment.discount"
                            :disabled="!isNew && (shipment.status != 'Created' && shipment.status != 'Draft' )"
                          ></v-text-field>
                      </v-flex-->

                    <v-flex xs12 sm1 md1 v-if="(isAdmin || isEMN)">
                      <v-text-field :id="'input_cost'" label="Cost €" v-model="shipment.cost" type="number" clearable></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm1 md1 v-if="(isAdmin || isEMN)">
                      <v-text-field :id="'input_price'" label="Price €" v-model="shipment.price" type="number" clearable></v-text-field>
                    </v-flex>


                    <v-flex xs12 sm3 md3>
                      <v-text-field :id="'input_status'" label="Status" readonly v-model="shipment.status" disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm2 md2
                      v-if="(isEMNCarrier || shipment.carrier == 'SPECIAL SERVICES') && (shipment.status != 'Created' && shipment.status != 'Draft')">
                      <v-text-field :id="'input_ddtNumber'" label="DDT Number" readonly v-model="shipment.num" disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 text-right>

                      <v-btn :id="'button_upsert'" data-test="upsert" v-if="$can('upsert', config.entityName) && !updateButtonDisabled"
                        class="mx-1 white--text" color="purple" :loading='loading' :disabled="!validForm || loading"
                        @click="save()"> {{ isNew ? 'Save' : 'Update' }} </v-btn>


                      <v-btn :id="'button_cancel'"
                        v-if="$can('upsert', config.entityName) && !isNew && ((this.shipment.status == 'Confirmed' && (isAdmin || isEMN)) || (this.shipment.status == 'Shipped' && isAdmin) || ((this.shipment.status == 'Created' || this.shipment.status == 'Draft') && (isAdmin || isEMN || isSender)))"
                        class="mx-1 white--text" color="red" @click="cancel()">REMOVE SHIPMENT</v-btn>

                      <!--v-btn
                          v-if="$can('delete', config.entityName) && !isNew && (this.shipment.status == 'Draft' || (this.shipment.status == 'Created' && (isAdmin || isEMN)))"
                          class="mx-1 white--text"
                          color="red"
                          @click="remove()">DELETE shipment</v-btn-->

                      <!--v-menu
                            open-on-hover
                            top
                            offset-y
                            v-if="$can('upsert', config.entityName) && !isNew && (isEMNCarrier || shipment.carrier == 'MARKEN') && (isAdmin || isEMN) && (shipment.status == 'Shipped' || shipment.status == 'Delivered' || shipment.status == 'Received')">
                            <template slot="activator" slot-scope="{ on }">
                                <v-btn
                                    v-on="shipment.file_logger ? on : {}"
                                    class="mx-1 font-weight-light"
                                    :disabled="isNew || !$can('upsert', 'shipment')"
                                    @click="pickFile()"
                                    :color="shipment.file_logger ? 'green' : 'pink' ">
                                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; Temp. Logger
                                </v-btn>
                              </template>
                              <div style="padding:10px"><a @click="downloadFileLogger()">{{shipment.file_logger}} </a></div>
                          </v-menu-->


                      <!--v-btn
                              class="mx-1 font-weight-light"
                              v-if="!(isAdmin || isEMN) && shipment.file_logger"
                              @click="downloadFileLogger()"
                              color="green">
                              <v-icon small>mdi-download</v-icon> &nbsp;&nbsp; Download Temp. Logger
                          </v-btn-->


                      <!--v-btn
                            v-if="$can('upsert', 'shipment') && shipment.status == 'Confirmed' && (isEMNCarrier || shipment.carrier == 'SPECIAL SERVICES')"
                            :disabled="!checkSave() && !validForm || loading"
                            class="mx-1 white--text"
                            color="primary"
                            :loading='loadingDDT'
                            @click="ddt()"> Download DDT</v-btn-->


                      <v-btn :id="'button_shipped'" v-if="$can('upsert', 'shipment') && shipment.status == 'Confirmed' && (isAdmin || isEMN)"
                        :disabled="!checkSave() && !validForm || loading || (!isEMNCarrier && !shipment.pickup_datetime) || !checkPickupDate"
                        class="mx-1 white--text" color="primary" :loading='loading' @click="shipped()">Shipped</v-btn>


                      <v-btn :id="'button_delivered'" v-if="$can('upsert', 'shipment') && shipment.status == 'Shipped' && (isAdmin || isEMN)"
                        :disabled="!checkSave() && !validForm || loading || (!isEMNCarrier && !shipment.delivery_datetime)"
                        class="mx-1 white--text" color="primary" :loading='loading' @click="delivered()">Delivered</v-btn>


                      <v-btn :id="'button_received'"
                        v-if="$can('upsert', 'shipment') && shipment.status == 'Delivered' && (isAdmin || isEMN || isInToAttentionOf)"
                        :disabled="!checkSave() && !validForm || loading || (!isEMNCarrier && !shipment.pickup_datetime) || !checkPickupDate"
                        class="mx-1 white--text" color="primary" :loading='loading' @click="received()">Received</v-btn>


                    </v-flex>


                    <v-flex xs12 sm12 md12 text-center v-if="!isNew && !packs.length && loadedPacks">
                      <v-banner rounded elevation="7" color="orange">
                        <!-- issue 199 -->
                        <span id="attentionmsg">
                          Attention!!! Please enter the contents of the shipment
                        </span>
                        <!-- issue 199 -->
                      </v-banner>
                    </v-flex>


                    <v-flex xs12 sm12 md12 text-right>
                      <v-data-table hide-default-footer v-if="!isNew" style="width:100%" class="elevation-1" :items="packs"
                        hide-default-header :headers="[
                          { text: 'n. Packages', value: 'pack', sortable: false, align: 'right' },
                          { text: 'Content', value: 'content', sortable: false, align: 'right' },
                          { text: 'Dimension', value: 'dimension', sortable: false, align: 'right' },
                          { text: 'weight in Kg', value: 'weight', sortable: false, align: 'right' },
                          { text: 'Notes on temperature', value: 'note', sortable: false, align: 'right' },
                          { text: 'Action', value: 'action', sortable: false, align: 'right' },
                        ]">


                        <template v-slot:header="{ props }">
                          <thead>
                            <tr>
                              <th colspan="6" class="headerPackages">
                                Shipment Contents
                              </th>
                            </tr>

                            <tr>
                              <th v-for="header in props.headers" :key="header.text" :class="[
                                header.align ? 'text-' + header.align : 'text-start',
                              ]">
                                <span>{{ header.text }}</span>
                              </th>
                            </tr>

                            <tr class="lighten-3"
                              v-if="$can('upsert', 'pack') && ((shipment.status == 'Created' && (isAdmin || isEMN)) || shipment.status == 'Draft')">
                              <td style="padding:10px">

                                <v-text-field :id="'input_package_pack'" type="number" label="n. Packages" min="1" v-model="newPack.pack" @change="roundNumber"
                                  :messages="packErrors.pack" :class="{ 'pack-invalid': packErrors.pack }"></v-text-field>


                              </td>
                              <td style="padding:10px">

                                <v-text-field :id="'input_package_content'" label="Content" v-model="newPack.content"></v-text-field>


                              </td>
                              <td style="padding:10px">

                                <v-text-field :id="'input_package_dimension'" label="Dimension" v-model="newPack.dimension"></v-text-field>

                              </td>
                              <td style="padding:10px">
                                <v-text-field :id="'button_package_weight'" type="number" label="weight in Kg" min="0" step="any" v-model="newPack.weight"
                                  :messages="packErrors.weight" :class="{ 'pack-invalid': packErrors.weight }"></v-text-field>
                              </td>

                              <!--td style="padding:10px">
                                  <v-text-field
                                      type="number"
                                      label="Temperature"
                                      v-model="newPack.temperature"
                                      ></v-text-field>
                                </td-->

                              <td style="padding:10px">

                                <v-text-field :id="'input_package_note'" label="Notes on temperature" v-model="newPack.note"
                                  placeholder="NA or Min Max"></v-text-field>

                              </td>

                              <td style="padding:10px">
                                <v-btn :id="'button_package_save'" small color="success" @click="upsertPack()" :disabled="!requiredPack" v-if="!isEditPack">
                                  <v-icon color="primary">mdi-plus</v-icon> Save Package
                                </v-btn>

                                <v-btn :id="'button_package_save'" small color="success" @click="upsertPack()" :disabled="!requiredPack" v-if="isEditPack">
                                  <v-icon color="primary">mdi-content-save</v-icon> Save Package
                                </v-btn>

                              </td>
                            </tr>

                          </thead>


                        </template>
                        
                        <template v-slot:item.action="{ item }">
                          <!-- Bottone Edit -->
                          <v-tooltip color="white" bottom v-if="$can('upsert', 'pack') && ((shipment.status == 'Created' && (isAdmin || isEMN)) || shipment.status == 'Draft')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :id="'button_package_edit'"
                                text
                                v-bind="attrs"
                                v-on="on"
                                @click="editPack(item)"
                              >
                                <v-icon color="primary">mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Package</span>
                          </v-tooltip>

                          <!-- Bottone Delete -->
                          <v-tooltip color="white" bottom v-if="$can('delete', 'pack') && ((shipment.status == 'Created' && (isAdmin || isEMN)) || shipment.status == 'Draft')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :id="'button_package_cancel'"
                                text
                                v-bind="attrs"
                                v-on="on"
                                @click="removePack(item)"
                              >
                                <v-icon color="primary">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Remove Package</span>
                          </v-tooltip>
                        </template>


                      </v-data-table>
                    </v-flex>

                    <v-flex xs12 sm12 md12 text-right>

                      <v-btn :id="'button_confirmAndCreate'" v-if="$can('upsert', config.entityName) && this.shipment.status == 'Draft'"
                        class="mx-1 white--text" color="success" :loading='loadingCreate'
                        :disabled="!validForm || loading || !packs.length" @click="create()"> Confirm & Create </v-btn>

                      <v-btn :id="'button_confirm'" v-if="$can('confirm', 'shipment') && shipment.status == 'Created' && packs.length && (waybillExists || isEMNCarrier || shipment.carrier === 'SPECIAL SERVICES')"
                        :disabled="!checkSave() && !validForm || loading || !this.shipment.carrier" class="mx-1 white--text"
                        color="primary" :loading='loadingConfirm' @click="confirm()"> Confirm Shipment</v-btn>

                    </v-flex>
                    <v-flex xs12 sm12 md12 text-right
                      v-if="['Created', 'Confirmed', 'Shipped', 'Delivered', 'Received'].includes(shipment.status)">
                      <v-data-table hide-default-footer v-if="!isNew" style="width:100%" class="elevation-1" :items="documents"
                        hide-default-header :headers="[
                          { text: 'Type', value: 'type', sortable: false, align: 'right' },
                          { text: 'File Name', value: 'file', sortable: false, align: 'right' },
                          { text: 'Action', value: 'action', sortable: false, align: 'right' },
                        ]">

                        <template v-slot:header="{ props }">
                          <thead>
                            <tr>
                              <th colspan="6" class="headerPackages">
                                Documents
                              </th>
                            </tr>

                            <tr>
                              <th v-for="header in props.headers" :key="header.text" :class="[
                                header.align ? 'text-' + header.align : 'text-start',
                              ]">
                                <span>{{ header.text }}</span>
                              </th>
                            </tr>

                            <tr class="lighten-3" v-if="$can('upsert', 'document') && (isAdmin || isEMN)">

                              <td colspan="2">
                                <v-select :id="'input_document_type'" dense style="width:300px" clearable label="Type"
                                  :items="['Temperature Logger', 'GPS Logger', 'Waybill', 'Other Document']"
                                  v-model="newDocument.type"></v-select>
                              </td>
                              <td>
                                <v-btn :id="'button_document_upload'" :disabled="!newDocument.type" text @click="pickFile()"
                                  v-if="$can('upsert', 'document') && (isAdmin || isEMN)">
                                  <v-icon color="primary">mdi-upload</v-icon>
                                </v-btn>
                              </td>

                            </tr>

                          </thead>

                        </template>

                        <template v-slot:item.action="{ item }">
                          <v-btn :id="'button_document_download'" :loading="item.loadingDownload" text
                            @click="item.action ? item.action(item) : downloadDocument(item)" v-if="$can('read', 'document')">
                            <v-icon color="primary">mdi-download</v-icon>
                          </v-btn>
                          <v-btn text @click="removeDocument(item)"
                            v-if="$can('delete', 'document') && shipment.status==='Created'">
                            <v-icon color="primary">mdi-delete</v-icon>
                          </v-btn>
                        </template>

                      </v-data-table>
                    </v-flex>

                    <v-flex>
                      &nbsp;
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-form>
          </v-col>
          <v-col cols="1" class="d-flex justify-end" v-if="$route.params.id">
            <v-tooltip top color="white">
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" :disabled="loading || !nextShipmentId" @click="navigateShipment(nextShipmentId)"  color="secondary">
                  Next
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>Next</span>
            </v-tooltip>
          </v-col>
        </v-row>

      </material-card>

    </v-flex>

    <input id="file" ref="file" type="file" style="display: none" accept=".pdf, application/pdf"
      @change="handleFileUpload()" />

  </v-container>
</template>

<script>
import { getDetail, getList, upsert, remove, post, download, put, uploadPdf } from '@/api/base_entity'
import config from './config_upsert.js'
import validators from '../../utils/validators.js'
import { upperFirst as uf } from 'lodash'
import { format } from 'date-fns'



export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: false,
      validators,
      config,
      loadedPacks: false,
      loadedDocuments: false,
      loading: false,
      loadingConfirm: false,
      loadingCreate: false,
      shipment: { pickup_id: null, delivery_id: null, pickup_hour: { start: '', end: '' } },
      newPack: {},
      newDocument: {},
      packs: [],
      documents: [],
      isEditPack: false,
      address: '',
      pickupPoint: {},
      deliveryPoint: {},
      menu_datePicker_pickupDate: false,
      loadingDDT: false,
      allDataTable:[],
      prevShipmentId:null,
      nextShipmentId:null,
    }
  },
  async created() {
    if (this.$route.params.id) {
      this.getData()
    }else if(this.isNew){
      this.shipment.delivery_within=1 //issue 197
    }
  },
  async mounted() {},
  asyncComputed: {
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.getData(); 
        this.updatePrevNextShipments();
      }
    },
    toAttentionOf(val) {
      if (val) {
        if (val.length == 1) {
          this.shipment.to_attention_of = val[0].id
        }
      }
    }
  },
  computed: {
    waybillExists(){
      return this.documents.filter(item=>item.type === 'Waybill').length  
    },
    toAttentionOf() {

      let users = []
      if (this.shipment.delivery_id) {
        if (this.deliveryPoint.site_id) {
          users = this.deliveryPoint.siteToAttentionOf
        }
        if (this.deliveryPoint.lab_id) {
          users = this.deliveryPoint.labToAttentionOf
        }
      }
      return users
    },
    isNew() {
      return this.shipment.id ? false : true
    },
    isEMNCarrier() {
      return this.shipment.carrier == 'EMN Logistic'
    },
    isEMN() {
      return this.$store.getters.user.role == 'EMN Logistic'
    },
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
    isSite() {
      return this.$store.getters.user.role == 'Site'
    },
    isLab() {
      return this.$store.getters.user.role == 'Lab'
    },
    isAttentionOf() {
      if (this.shipment.to_attention_of === null) {
        return true
      }
      return this.$store.getters.user.account_id == this.shipment?.to_attention_of
    },
    isInToAttentionOf() {
      if (!this.toAttentionOf) {
        return false
      }
      return this.toAttentionOf.filter(el => this.$store.getters.user.account_id == el.id).length
    },
    isSender() {
      if (this.isSite) {
        return this.$store.getters.user.site_id == this.shipment?.pickup?.site_id
      }
      if (this.isLab) {
        return this.$store.getters.user.lab_id == this.shipment?.pickup?.lab_id
      }
      return false
    },
    requiredPack() {
      return Number(this.newPack.pack) > 0 && this.newPack.content && this.newPack.dimension && Number(this.newPack.weight) > 0 && this.newPack.note ? true : false
    },
    packErrors() {
      const errors = {}
      const isEmpty = v => v === undefined || v === null || String(v).trim() === ''
      if (!isEmpty(this.newPack.pack) && !(Number(this.newPack.pack) > 0)) errors.pack = 'Must be greater than 0'
      if (!isEmpty(this.newPack.weight) && !(Number(this.newPack.weight) > 0)) errors.weight = 'Must be greater than 0'
      return errors
    },
    pickupTimeIntervalDisabled() {
      if (this.isAdmin || this.isEMN) {
        return this.shipment.status == 'Shipped' || this.shipment.status == 'Delivered' || this.shipment.status == 'Canceled' ? true : false
      } else {
        return !this.isNew && this.shipment.status != 'Created' && this.shipment.status != 'Draft'
      }
    },
    pickupNoteDisabled() {
      if (this.isAdmin || this.isEMN) {
        return this.shipment.status == 'Confirmed' ? false : true
      } else {
        return true
      }
    },
    deliveryNoteDisabled() {
      if (this.isAdmin || this.isEMN) {
        return this.shipment.status == 'Shipped' || this.shipment.status == 'Delivered' ? false : true
      } else {
        return true
      }
    },
    updateButtonDisabled() {
      if (!this.isAdmin && !this.isEMN) {
        return !this.isNew && this.shipment.status != 'Draft' ? true : false
      }

      return false //this.shipment.status == 'Canceled'

    },
    // shipmentCost() {
    //   const discount = this.shipment.discount ? this.shipment.discount : 0
    //   let value = 0
    //   if(this.shipment.pickup) {
    //     value = (this.shipment.pickup.cost - this.shipment.pickup.cost / 100 * discount)
    //   }
    //   return value
    // },
    checkPickupDate() {
      const dObj = new Date(this.shipment.pickup_date)
      const today = new Date();
      if (today >= dObj) {
        return true
      }
      return false
    }
  },
  methods: {
     async updatePrevNextShipments() {
    const res = await getList('shipment', {}, {
      defaultSortBy: "id",
      descending: true,
      rowsPerPage: 1000,
      sortBy: "id"
    });

    const data = res.data || [];
    this.allDataTable = data;

    const index = data.findIndex(item => item.id == Number(this.$route.params.id));
    this.prevShipmentId = data[index - 1]?.id || null;
    this.nextShipmentId = data[index + 1]?.id || null;
  },
    navigateShipment(id){
      this.$router.push(`/shipment/${id}`)
    },
    roundNumber(){
      this.newPack.pack=Math.round(this.newPack.pack);
    },
    removeDocument(document){
        upsert('document', document).then((ret) => {
        this.$root.$emit('openSnackbar', {
          message: 'Document "' + document.type  + '" delete correctly',
          color: 'success'
        })
        this.document = ret.data
        this.loadDocuments()
      })
        .catch(e => {
          const msg = e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0] || e.response.data.message
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the ' + uf(this.config.entityName) + ' update. ' +
              msg || 'Error',
            color: 'error'
          })
        })
        .finally(() => {
          this.loading = false
          this.loadedDocuments = true
        })
    },
    // Per i Site le spedizioni si possono fare solo il Lunedì, il Martedì e il Mercoledì
    allowedDates(val) {
      const cDate = new Date(val)
      return [1,2,3].includes(cDate.getDay()) || this.isAdmin || this.isEMN || this.isLab
    },
    pickupPointFilters() {
      if (this.isNew) {
        if (this.isAdmin || this.isEMN) {
            //funzionamento standard
            if (this.isAdmin || this.isEMN) {
              return (val) => {
                return { id : "!=" + this.shipment.delivery_id, name: "%" + val + "%" };
              };
            }
        }

        if (this.isSite) {
          return (val) => {
            let f = { site_id: this.$store.getters.user.site_id };
            if (val) {
              f["name"] = "%" + val + "%";
            }
            return f;
          };
        }

        if (this.isLab) {
          return (val) => {
            let f = { lab_id: this.$store.getters.user.lab_id };
            if (val) {
              f["name"] = "%" + val + "%";
            }
            return f;
          };
        }
      }

      return null;
    },
    deliveryPointFilters() {
      if (this.isNew) {
        if (this.isAdmin || this.isEMN) {
          return (val) => {
            return {
              lab_id: "!=NULL",
              "labToAttentionOf.surname": "!=NULL",
              "id": "!="+this.shipment.pickup_id,
              b: [
                { name: "%" + val + "%" },
                { "labToAttentionOf.surname": "%" + val + "%" },
                { "labToAttentionOf.name": "%" + val + "%" }
              ],
            };
          };
        }

        // I Site possono spedire ad altri site oppure ai laboratori
        if (this.isSite) {
          return (val) => {
            let f = {
              //a: [{"site_id": '!=' + this.$store.getters.user.site_id}, {"site_id":"NULL"}],
              lab_id: "!=NULL",
              "labToAttentionOf.surname": "!=NULL",
            };

            if (val) {
              f["c"] = [
                { lab_id: "!=NULL", name: "%" + val + "%" },
                { "siteToAttentionOf.surname": "%" + val + "%" },
                { "siteToAttentionOf.name": "%" + val + "%" },
                { "labToAttentionOf.surname": "%" + val + "%" },
                { "labToAttentionOf.name": "%" + val + "%" },
              ];
            }

            return f;
          };
        }

        // I laboratori possono spedire solo ad altri laboratori
        if (this.isLab) {
          return (val) => {
            let f = {
              a: {
                lab_id: "!=NULL",
                b: {
                  // questo barbatrucco perchè lab_id è una chiave duplicata e quindi non si può mettere 2 volte nello stesso oggetto
                  lab_id: "!=" + this.$store.getters.user.lab_id,
                },
                "labToAttentionOf.surname": "!=NULL",
              },
            };

            if (val) {
              f["b"] = [
                { name: "%" + val + "%" },
                { "labToAttentionOf.surname": "%" + val + "%" },
                { "labToAttentionOf.name": "%" + val + "%" },
              ];
            }

            return f;
          };
        }
      }

      return null;
    },
    async getData() {
      this.loading = true
      if(this.$route.params.id){
          this.shipment = await getDetail('shipment', this.$route.params.id, {"x-foreign-levels":2})
          
          if (!this.shipment.pickup_hour) {
            this.shipment.pickup_hour = {}
          }

          this.pickupPoint = this.shipment.pickup
          this.deliveryPoint = this.shipment.delivery
      }
      

      // this.deliveryPoint = await getDetail('point', this.shipment.delivery.id)

      this.loadPacks()
      this.loadDocuments()
      this.loading = false
    },
    setPickupPoint(v) {
      this.shipment.pickup = this.pickupPoint = v
    },
    setDeliveryPoint(v) {
      this.shipment.delivery = this.deliveryPoint = v
    },
    checkSave() {
      return !this.isNew
    },
    async loadPacks() {
      const packs = await getList('pack', { shipment_id: this.shipment.id }, { rowsPerPage: -1 })
      this.packs = packs['data']
      this.loadedPacks = true
    },
    async loadDocuments() {
      //TODO aggiunto deleted_at:null da controllare 
      const documents = await getList('document', { shipment_id: this.shipment.id ,deleted_at:null }, { rowsPerPage: -1, sortBy: "insert_at", descending: true })
      this.documents = documents['data']

      if ((this.isEMNCarrier || this.shipment.carrier == 'SPECIAL SERVICES') && ['Confirmed', 'Shipped', 'Delivered', 'Received'].includes(this.shipment.status)) {
        // ddt
        const ddtDoc = {
          type: 'DDT',
          file: 'generated on the fly',
          action: this.ddt,
          loadingDownload: false
        }
        this.documents.push(ddtDoc)
      }
      
      this.documents = this.documents.map(el => { el.loadingDownload = false; return el })
      this.loadedDocuments = true
    },
    save() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      if (this.isNew) {
        if (this.isAdmin || this.isEMN) {
          this.shipment['status'] = 'Created'
        } else {
          this.shipment['status'] = 'Draft'
        }
      }      
      upsert('shipment', this.shipment).then((ret) => {
        this.$root.$emit('openSnackbar', {
          message: (this.title || this.config.title || uf(this.config.entityName)) + ' updated correctly',
          color: 'success'
        })

        //issue 199
        setTimeout(() => {
          //window.scrollTo(0, document.body.scrollHeight);
          document.getElementById("attentionmsg").scrollIntoView()
        },500)
        //issue 199

        if (this.isNew) {
          this.$router.push('/shipment/' + ret.data.id)
        }
        this.shipment = ret.data
      })
        .catch(e => {
          const msg = e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0] || e.response.data.message
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the ' + uf(this.config.entityName) + ' update. ' +
              msg || 'Error',
            color: 'error'
          })
        })
        .finally(() => {
          this.loading = false
          this.loadedPacks = true
        })
    },
    async cancel() {
      const ret = await this.$root.$confirm.open('Confirm removal', 'Are you sure to remove this item?', { color: 'red' })
      if (!ret) {
        return
      }

      upsert('shipment/canceled', this.shipment).then((ret) => {

        this.shipment = ret.data

        this.$root.$emit('openSnackbar', {
          message: (this.title || this.config.title || uf(this.config.entityName)) + ' canceled correctly',
          color: 'success'
        })
      }).catch(e => {
        const msg = e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0] || e.response.data.message
        this.$root.$emit('openSnackbar', {
          message: 'An Error occurred during the Shipment cancel' +
            msg || 'Error',
          color: 'error'
        })
      })
    },
    upsertPack() {
      if (!this.requiredPack) return

      this.isEditPack = false
      this.newPack.shipment_id = this.shipment.id
      this.newPack.arrayToAttentionOf=this.toAttentionOf
      upsert('pack', this.newPack).then(() => {
        this.$root.$emit('openSnackbar', {
          message: 'Pack updated correctly',
          color: 'success'
        })
        this.loadPacks()
      })
        .catch(e => {
          const msg = e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0] || e.response.data.message
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the Pack update. ' +
              msg || 'Error',
            color: 'error'
          })
        }).finally(() => {
          this.newPack = {}
        })

    },
    editPack(pack) {
      this.newPack = JSON.parse(JSON.stringify(pack))
      this.isEditPack = true
    },
    removePack(pack) {

      const id = pack.id
      this.isEditPack = false
      this.newPack = {}

      remove('pack', { id }).then(() => {
        this.loadPacks()
      })
    },
    create() {
      this.loadingCreate = true
      this.shipment.arrayToAttentionOf=this.toAttentionOf
      post('/shipment/create/' + this.shipment.id, this.shipment).then(() => {
        this.getData()
        this.$root.$emit('openSnackbar', {
          message: 'Shipment created successly',
          color: 'success'
        })

      }).finally(() => {
        this.loadingCreate = false
      })
    },
    confirm() {

      this.loadingConfirm = true
      post('/shipment/confirm/' + this.shipment.id, this.shipment).then(() => {
        this.getData()
        this.$root.$emit('openSnackbar', {
          message: 'Shipment confirmed successly',
          color: 'success'
        })

      }).finally(() => {
        this.loadingConfirm = false
      })
    },
    shipped() {

      if (this.shipment.pickup_datetime instanceof Date) {
        this.shipment.pickup_datetime = format(this.shipment.pickup_datetime, 'yyyy-MM-dd HH:mm:ss')
      }

      put('shipment/shipped', this.shipment.id, this.shipment).then((ret) => {
        this.$root.$emit('openSnackbar', {
          message: 'Shipment updated correctly : SHIPPED',
          color: 'success'
        })
        this.shipment = ret.data
      })
    },
    delivered() {

      if (this.shipment.delivery_datetime instanceof Date) {
        this.shipment.delivery_datetime = format(this.shipment.delivery_datetime, 'yyyy-MM-dd HH:mm:ss')
      }

      put('shipment/delivered', this.shipment.id, this.shipment).then((ret) => {
        this.$root.$emit('openSnackbar', {
          message: 'Shipment updated correctly : DELIVERED',
          color: 'success'
        })
        this.shipment = ret.data
      })
    },
    received() {
      put('shipment/received', this.shipment.id, this.shipment).then((ret) => {
        this.$root.$emit('openSnackbar', {
          message: 'Shipment updated correctly : RECEIVED',
          color: 'success'
        })
        this.shipment = ret.data
      })
    },
    ddt(item) {
      // this.loadingDDT = true
      item.loadingDownload = true
      download('download/ddt/' + this.shipment.id,).then(() => {
        this.$root.$emit('openSnackbar', {
          message: 'DDT downloaded correctly',
          color: 'success'
        })
      }).finally(() => {
        // this.loadingDDT = false
        item.loadingDownload = false
      })
    },
    qrCodeLink() {
      let routeData = this.$router.resolve({ name: 'ShipmentDriver', params: { id: this.shipment.id } });
      window.open(routeData.href, '_blank');
    },
    pickFile() {
      
      this.$refs.file.click();
    },
    handleFileUpload() {
     
      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('file', file);
      formData.append('shipment_id', this.shipment.id);

      if(this.newDocument.type == 'Other Document') {
        this.newDocument.type = this.newDocument.type + ' - ' + file.name
      }

      uploadPdf(formData, this.newDocument.type).then(() => {
        this.$store.dispatch("app/stopLoading");
        this.$root.$emit('openSnackbar', {
          message: 'Document "' + this.newDocument.type + '" uploaded correctly',
          color: 'success'
        })
        this.loadDocuments()
      }).catch((e) => {

        this.$root.$emit('openSnackbar', {
          message: "An Error occurred during pdf upload " +
            e.response.data.message,
          color: 'error'
        })

        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
      this.$refs.file.value = '';
    },
    downloadDocument(item) {

      item.loadingDownload = true
      this.$store.dispatch("app/startLoading");

      download('pdf/download/' + item.id,).then(() => {
        this.$store.dispatch("app/stopLoading");
        this.$root.$emit('openSnackbar', {
          message: "Document downloaded correctly",
          color: 'success'
        })
      }).catch(e => {

        this.$root.$emit('openSnackbar', {
          message: "An Error occurred during pdf download : " + (e.response.data.message || e.response.statusText),
          color: 'error'
        })

        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        item.loadingDownload = false
      });
    },
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}

.headerPackages {
  background: rgb(193, 193, 193);
  height: 50px;
}

.headerDocuments {
  background: rgb(0, 85, 255);
}

.pack-invalid .v-messages {
  color: #ff5252 !important;
}
</style>
